import { cn } from "@/lib/utils";

interface ProgressBarProps {
  progress: number;
  className?: string;
  classNameBar?: string;
}

const commonDiv = "overflow-hidden bg-white-20";
const commonBar = "h-2 rounded-r-full bg-lime-100";

export const ProgressBar = ({
  progress,
  className,
  classNameBar,
}: ProgressBarProps) => {
  const classNamesDiv = cn(commonDiv, className);
  const classNamesBar = cn(commonBar, classNameBar);
  return (
    <div className={classNamesDiv}>
      <div style={{ width: `${progress}%` }} className={classNamesBar} />
    </div>
  );
};
